import React, { useEffect } from "react";
import Header from "../../components/Navbar";
import Footer from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import JmifHistory from "./JmifHistory";
import MissionVision from "./MissionVision";
import FacultyStaff from "./FacultyStaff";
import Hymn from "./Hymn";
import { Helmet } from "react-helmet-async";
import jmifPic from "../../image/jmif.jpg";

function AboutUs() {
  useEffect(() => {
    // Smooth scrolling to the section if the URL contains a hash
    if (window.location.hash) {
      const targetId = window.location.hash;
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, []);
  return (
    <div>
      <Helmet>
        <title>About JMIF | Our History, Mission, and Vision</title>
        <meta
          name="description"
          content="Jamiatu Marawi Al-Islamia Foundation (JMIF) is a sectarian,
      non-profit, non-stock Islamic Institution and a Madrasah (Arabic
      word for school) system of ..."
        />
        <meta
          name="keywords"
          content="about JMIF, mission, educational philosophy, history, vision, staff, academic approach"
        />
        <link rel="canonical" href="https://jmif-73f1a.web.app/about" />
        <meta
          property="og:title"
          content="About JMIF | History, Mission, and Vision"
        />
        <meta
          property="og:description"
          content="Jamiatu Marawi Al-Islamia Foundation (JMIF) is a sectarian,
      non-profit, non-stock Islamic Institution and a Madrasah (Arabic
      word for school) system of ..."
        />
        <meta property="og:image" content={jmifPic} />
        <meta
          property="og:url"
          content="https://jmif-73f1a.web.app/about"
        />{" "}
        <meta property="og:type" content="website" />
      </Helmet>

      <Header />
      <main className="flex flex-col">
        {/* section 1 */} {/* title page */}
        <PageHeader
          pageTitle={"About JMIF"}
          description={
            " Read more about us. Our history, mission, vision and many other you might love."
          }
        />
        {/* Numbers about the school */}
        <div className=" responsive-padding grid grid-cols-2 md:grid-cols-4 gap-4 laptopSm:gap-6 mt-10">
          <div className="flex flex-col items-center font-montserrat py-2">
            <span className=" text-2xl md:text-[35px] text-text-normal font-black">
              2
            </span>
            <span className="text-base md:text-xl text-primary-normal">
              Location
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center font-montserrat py-2">
            <span className=" text-2xl md:text-[35px] text-text-normal font-black">
              50
            </span>
            <span className="text-base md:text-xl text-primary-normal capitalize text-center">
              Years of quality Education
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center font-montserrat py-2">
            <span className="text-2xl md:text-[35px] text-text-normal font-black">
              1000+
            </span>
            <span className="text-base md:text-xl text-primary-normal capitalize">
              Students
            </span>{" "}
          </div>{" "}
          <div className="flex flex-col items-center font-montserrat py-2">
            <span className="text-2xl md:text-[35px] text-text-normal font-black">
              50+
            </span>
            <span className="text-base md:text-xl text-primary-normal capitalize">
              Faculty & Staff
            </span>{" "}
          </div>
        </div>
        {/* history */}
        <JmifHistory />
        {/* Mission, Vission, Goals & Objectives */}
        <MissionVision />
        {/* Faculty & Staff */}
        <FacultyStaff />
        {/* Hymn */}
        <Hymn />{" "}
      </main>
      <Footer />
    </div>
  );
}

export default AboutUs;
